import { render, staticRenderFns } from "./Chars.vue?vue&type=template&id=37ece66a&scoped=true"
import script from "./Chars.vue?vue&type=script&lang=js"
export * from "./Chars.vue?vue&type=script&lang=js"
import style0 from "./Chars.vue?vue&type=style&index=0&id=37ece66a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ece66a",
  null
  
)

export default component.exports